import { schema } from "normalizr";

const availabilityRecord = new schema.Entity(`availability_records`);
const arrayOfAvailabilityRecords = [availabilityRecord];

export { availabilityRecord, arrayOfAvailabilityRecords };
